import script from "./MysticCommunity.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticCommunity.vue?vue&type=script&setup=true&lang=js"

import "./MysticCommunity.vue?vue&type=style&index=0&id=99823ff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99823ff8"]])

export default __exports__